import * as React from "react"
const FacebookLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#4F2E03"
      d="M22.68 0H1.32A1.32 1.32 0 0 0 0 1.32v21.36A1.32 1.32 0 0 0 1.32 24h11.496v-9.3h-3.12v-3.6h3.12V8.4a4.368 4.368 0 0 1 4.656-4.8c.934-.006 1.867.042 2.796.144v3.24H18.36c-1.512 0-1.8.72-1.8 1.764v2.316h3.6l-.468 3.6H16.56V24h6.12A1.319 1.319 0 0 0 24 22.68V1.32A1.319 1.319 0 0 0 22.68 0Z"
    />
  </svg>
)
export default FacebookLogo
